module.exports = __webpack_public_path__ + "media/images/icon_payment-154a15bafc4c8adb614de586aadb62c2.png";